var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-goods-item",on:{"click":_vm.onItem}},[_c('p',[_vm._v(_vm._s(_vm.item.title))]),_c('div',{staticClass:"info"},[_c('van-tag',{attrs:{"color":"#E6F2FE","text-color":"#1A75C8","size":"medium"}},[_vm._v(_vm._s(_vm.item.name))]),_c('span',[_vm._v(_vm._s(_vm.item.createTime))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }